import React from "react";

const SvgMobileBg = props => (
  <svg id="mobile-bg" viewBox="0 0 320 5693" {...props}>
    <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <path
        id="form-align"
        d="M21,5690.06519 L21,5596"
        stroke="#009EE3"
        strokeWidth={10}
        strokeLinejoin="bevel"
        strokeDasharray="18 8"
      />
      <path
        d="M0,4003 L220,4003 C250.927946,4003 276,4028.07205 276,4059 L276,4740 C276,4770.92795 250.927946,4796 220,4796 L0,4796 L0,4003 Z"
        id="Rectangle"
        fill="#073D61"
      />
      <path
        d="M285,1996 L320,1996 L320,2718 L21,2718 L21,2431.3164 C21,2400.38846 46.072054,2375.3164 77,2375.3164 C77.1677444,2375.3164 77.3354879,2375.31715 77.5032255,2375.31866 L228.496774,2376.67557 C259.423472,2376.95349 284.719815,2352.10775 284.997739,2321.18106 C284.999246,2321.01332 285,2320.84558 285,2320.67783 L285,1996 Z"
        id="Rectangle"
        fill="#F0F1F6"
      />
      <rect
        id="Rectangle"
        fill="#073D61"
        x={0}
        y={0}
        width={320}
        height={1813}
      />
      <path
        d="M24,1806 L320,1806 L320,1924 L80,1924 C49.072054,1924 24,1898.92795 24,1868 L24,1806 Z"
        id="Rectangle"
        fill="#073D61"
      />
      <polygon
        id="Rectangle-Copy"
        fill="#073D61"
        points="250 1919 320 1919 320 1996 280.911216 1996 272.838832 1949.13375 250 1927.14634"
      />
      <polygon
        id="Rectangle-Copy"
        fill="#073D61"
        transform="translate(35.000000, 3978.500000) scale(-1, -1) translate(-35.000000, -3978.500000) "
        points="0 3940 70 3940 70 4017 49 4017 40.5754872 3978.5 22 3954"
      />
      <polygon
        id="Rectangle-Copy"
        fill="#073D61"
        transform="translate(35.000000, 4828.500000) scale(-1, 1) translate(-35.000000, -4828.500000) "
        points="0 4790 70 4790 70 4867 49 4867 40.5754872 4828.5 22 4804"
      />
      <path
        id="reporting-cloud"
        d="M24,3145.95758 L200.417969,3145.95758 L200.417468,3145.88929 C200.190517,3114.96217 225.077916,3089.70681 256.005029,3089.47986 C256.299613,3089.4777 256.594209,3089.47787 256.888791,3089.48035 L320,3090.01325 L320,3539 L24,3539 L24,3145.95758 Z"
        fill="#F0F1F6"
      />
      <g id="intro-desc-align" transform="translate(0.000000, 231.000000)">
        <path
          d="M176,0 L145.392096,1.77635684e-14 C129.928123,2.06042541e-14 117.392096,12.536027 117.392096,28 L117.392096,121.91438 C117.392096,137.378353 104.856069,149.91438 89.3920957,149.91438 L28,149.91438 C12.536027,149.91438 2.21451084e-13,162.450407 2.09610107e-13,177.91438 L0,205 C-3.24431272e-14,220.463973 12.536027,233 28,233 L176,233"
          id="Path-3-Copy"
          stroke="#FFFFFF"
          strokeWidth={8.5}
          opacity={0.156306612}
          transform="translate(88.000000, 116.500000) scale(-1, 1) translate(-88.000000, -116.500000) "
        />
        <path
          id="chevron-align"
          d="M58.5,80.5 C62.3662532,80.5 65.5,77.3662532 65.5,73.5 C65.5,69.6337468 62.3662532,66.5 58.5,66.5 C54.6337468,66.5 51.5,69.6337468 51.5,73.5 C51.5,77.3662532 54.6337468,80.5 58.5,80.5 Z"
          stroke="#2D5B79"
          strokeWidth={5}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M176,201.5 C179.866253,201.5 183,198.366253 183,194.5 C183,190.633747 179.866253,187.5 176,187.5 C172.133747,187.5 169,190.633747 169,194.5 C169,198.366253 172.133747,201.5 176,201.5 Z"
          id="Stroke-15-Copy-7"
          stroke="#2D5B79"
          strokeWidth={5}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g id="Group-36" transform="translate(244.000000, 0.000000)">
        <path
          id="intro-align"
          d="M7,0 L7,57 C7,84.6142375 29.3857625,107 57,107 L74,107 L76,107"
          stroke="#FFFFFF"
          strokeWidth={8.5}
          opacity={0.156306612}
        />
        <path
          d="M7,69.8262911 C10.8662532,69.8262911 14,66.6778318 14,62.7934272 C14,58.9090226 10.8662532,55.7605634 7,55.7605634 C3.13374682,55.7605634 0,58.9090226 0,62.7934272 C0,66.6778318 3.13374682,69.8262911 7,69.8262911 Z"
          id="Stroke-15-Copy-8"
          stroke="#2D5B79"
          strokeWidth={5}
          fill="#073D61"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        id="trading-pagination-align"
        d="M21.6824264,1459 L32.4245128,1459"
        stroke="#009EE3"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="reporting-submit-align"
        d="M23.6824264,3622 L34.4245128,3622"
        stroke="#009EE3"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="reporting-delegated-align"
        d="M23.6824264,3824 L34.4245128,3824"
        stroke="#009EE3"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="uti-align"
        d="M82.6824264,2381 L82.6824264,2391.53366"
        stroke="#009EE3"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="main-line"
        d="M320,986 L77,986 C46.072054,986 21,1011.07205 21,1042 L21,1866.69215 C21,1897.6201 46.072054,1922.69215 77,1922.69215 L224.054687,1922.69215 C254.982633,1922.69215 280.054687,1947.76421 280.054687,1978.69215 L280.054687,2321.66607 C280.054687,2352.59401 254.982633,2377.66607 224.054687,2377.66607 L77,2377.66607 C46.072054,2377.66607 21,2402.73812 21,2433.66607 L21,3948.48926 C21,3979.41721 46.072054,4004.48926 77,4004.48926 L218.054777,4004.48926 C248.982723,4004.48926 274.054777,4029.56132 274.054777,4060.48926 L274.054777,4740.30495 C274.054777,4771.23289 248.982723,4796.30495 218.054777,4796.30495 L77,4796.30495 C46.072054,4796.30495 21,4821.377 21,4852.30495 L21,5596"
        stroke="#009EE3"
        strokeWidth={10}
        style={{
          strokeLinecap: "round"
        }}
      />
      <path
        id="yellow-line"
        d="M320,986 L77,986 C46.072054,986 21,1011.07205 21,1042 L21,1866.69215 C21,1897.6201 46.072054,1922.69215 77,1922.69215 L224.054687,1922.69215 C254.982633,1922.69215 280.054687,1947.76421 280.054687,1978.69215 L280.054687,2321.66607 C280.054687,2352.59401 254.982633,2377.66607 224.054687,2377.66607 L77,2377.66607 C46.072054,2377.66607 21,2402.73812 21,2433.66607 L21,3948.48926 C21,3979.41721 46.072054,4004.48926 77,4004.48926 L218.054777,4004.48926 C248.982723,4004.48926 274.054777,4029.56132 274.054777,4060.48926 L274.054777,4740.30495 C274.054777,4771.23289 248.982723,4796.30495 218.054777,4796.30495 L77,4796.30495 C46.072054,4796.30495 21,4821.377 21,4852.30495 L21,5596"
        stroke="#fede00"
        style={{
          strokeLinecap: "round"
        }}
        strokeWidth={10}
      />
      <path
        id="trading-align"
        d="M21,1237 C25.9708969,1237 30,1232.9709 30,1228 C30,1223.0291 25.9708969,1219 21,1219 C16.0291031,1219 12,1223.0291 12,1228 C12,1232.9709 16.0291031,1237 21,1237 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="matching-align"
        d="M57,1929 C61.9708969,1929 66,1924.9709 66,1920 C66,1915.0291 61.9708969,1911 57,1911 C52.0291031,1911 48,1915.0291 48,1920 C48,1924.9709 52.0291031,1929 57,1929 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="reporting-align"
        d="M21,2945 C25.9708969,2945 30,2940.9709 30,2936 C30,2931.0291 25.9708969,2927 21,2927 C16.0291031,2927 12,2931.0291 12,2936 C12,2940.9709 16.0291031,2945 21,2945 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="insight-align"
        d="M57,4012 C61.9708969,4012 66,4007.9709 66,4003 C66,3998.0291 61.9708969,3994 57,3994 C52.0291031,3994 48,3998.0291 48,4003 C48,4007.9709 52.0291031,4012 57,4012 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="sftr-align"
        d="M21,4903 C25.9708969,4903 30,4898.9709 30,4894 C30,4889.0291 25.9708969,4885 21,4885 C16.0291031,4885 12,4889.0291 12,4894 C12,4898.9709 16.0291031,4903 21,4903 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="form-wrap-align"
        d="M21,5690 C25.9708969,5690 30,5685.9709 30,5681 C30,5676.0291 25.9708969,5672 21,5672 C16.0291031,5672 12,5676.0291 12,5681 C12,5685.9709 16.0291031,5690 21,5690 Z"
        stroke="#FDDC00"
        strokeWidth={6}
        fill="#073D61"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgMobileBg;




// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/MobileBG.jsx